<template>
  <div class="site-wrapper">
    <Header />
    <main>
      <h1>Statistik</h1>
      <p class="body">
        Diagrammet visar procentuellt vart användarna satt sin gräns.
      </p>
      <label for="story">Välj story</label>
      <select id="story" v-model="storyId" @change="onStoryChange">
        <option v-for="s in stories" :key="s.id" :value="s.id">
          {{ s.Title }}({{ s.MinAge }} - {{ s.MaxAge }})
        </option>
      </select>
      <label for="age">Filtrera efter ålder</label>
      <select id="age" v-model="filter.age">
        <option :value="false">ej aktiv</option>
        <option v-for="o in ageOptions" :key="o" :value="o">
          {{ o }}
        </option>
      </select>
      <ul class="stats">
        <li
          v-for="(item, index) in getOverallStatsForStory(storyId, filter)
            .stats"
          :key="index"
        >
          <strong>{{ item.label }}:</strong>
          {{ item.value }}
        </li>
      </ul>
      <apexcharts
        type="bar"
        height="550"
        :options="chartOptions"
        :series="getStoryLimitDataSeries(storyId, filter, currentStory)"
      ></apexcharts>

      <div v-if="messages.length" class="message-wrapper">
        <h2>Meddelanden</h2>
        <Feedback v-for="(msg, index) in messages" :key="index" :data="msg" />
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import apexcharts from 'vue-apexcharts';

import Footer from '@/components/Footer.vue';
import Feedback from '@/components/Feedback.vue';
import Header from '@/components/Header.vue';
import { mapState } from 'vuex';
export default {
  components: {
    Footer,
    Header,
    apexcharts,
    Feedback
  },
  filters: {
    number: function(value) {
      return new Intl.NumberFormat('sv-SE', {
        maximumFractionDigits: 2
      }).format(value);
    }
  },
  data() {
    return {
      dataLoaded: false,
      storyId: 1,
      filter: { age: false },
      chartOptions: {
        chart: {
          type: 'bar',
          height: 550,
          width: '100%'
        },
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        legend: {
          show: true,
          showForSingleSeries: false,
          fontSize: '18px'
        },
        dataLabels: {
          enabled: false,
          formatter: (val, opts) => {
            return this.$options.filters.number(val) + ' %';
          },
          style: {
            fontSize: '18px'
          }
        },
        tooltip: {
          y: {
            formatter: (val, opts) => {
              return this.$options.filters.number(val) + ' %';
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              fontSize: '18px'
            },
            formatter: function(value) {
              return parseInt(value);
            }
          },
          title: {
            text: 'Procent',
            style: {
              fontSize: '18px'
            }
          }
        },
        xaxis: {
          labels: {
            style: {
              fontSize: '18px'
            }
          },
          title: {
            text: 'Gräns',
            style: {
              fontSize: '18px'
            }
          }
        }
      }
    };
  },
  computed: {
    ...mapState('stories', ['stories']),
    ...mapGetters({
      getStoryLimitDataSeries: 'stats/getStoryLimitDataSeries',
      getStatsForStory: 'stats/getStatsForStory',
      getOverallStatsForStory: 'stats/getOverallStatsForStory',
      getMessagesForStory: 'stats/getMessagesForStory'
    }),
    currentStory() {
      return this.stories.find(s => s.id === this.storyId);
    },
    ageOptions() {
      return [
        ...new Set(this.getStatsForStory(this.storyId).map(value => value.age))
      ].sort((a, b) => a - b);
    },
    messages() {
      return this.getOverallStatsForStory(this.storyId, this.filter).messages;
    }
  },
  created() {
    const statsPromise = this.$store.dispatch('stats/load');
    const storiesPromise = this.$store.dispatch('stories/load');

    Promise.all([statsPromise, storiesPromise]).then(values => {
      this.dataLoaded = true;
    });
  },
  methods: {
    onStoryChange() {
      this.filter = { age: false };
    }
  }
};
</script>

<style lang="scss" scoped>
.body {
  margin-bottom: 60px;
}

label {
  display: block;
  font-weight: 600;
}

select {
  border: 1px solid $orange;
  font-size: 18px;
  height: 45px;
  margin-bottom: 40px;
  max-width: 500px;
  padding: 5px 10px;
  width: 100%;
}

.stats {
  list-style: none;
  margin: 0;
  padding: 0;
}
</style>
